<template>
  <master-layout>
    <div
      :class="{
        'top-0': !showHeader,
        'top-navbar-height': showHeader,
      }"
    >
      <BackButton
        variant="inline"
        :is-gic="isGICConfType"
        data-test-id="gensapp-experiencesignup-back"
        @click="back"
      />
      <div class="px-[24px]">
        <h1 class="page-title">
          {{ $t('copy.profilePage.personalQr') }}
        </h1>
      </div>
      <div class="flex justify-center">
        <div
          class="w-[327px] lg:w-[680px] mt-[12px] inline-flex lg:flex flex-col items-center gap-[24px]"
        >
          <div
            class="w-[279px] lg:w-[287px] h-[279px] lg:h-[287px] drop-shadow-photoqr bg-yellow rounded-[64px] flex items-center justify-center mx-auto"
          >
            <div
              class="bg-white rounded-[54px] h-[249px] lg:h-[247px] w-[249px] lg:w-[247px] flex items-center justify-center"
            >
              <div class="block lg:hidden">
                <qrcode-vue
                  :value="'https://gens.bio/' + hashId"
                  :size="188.51"
                  level="H"
                  data-test-id="gensapp-photodrop-qrcode"
                  v-bind:class="{
                    'shadow-[0_0_10px_5px_#a7a7a7]': this.isSamsung,
                  }"
                />
              </div>
              <div class="hidden lg:block">
                <qrcode-vue
                  :value="'https://gens.bio/' + hashId"
                  :size="200"
                  level="H"
                  data-test-id="gensapp-photodrop-qrcode"
                  v-bind:class="{
                    'shadow-[0_0_10px_5px_#a7a7a7]': this.isSamsung,
                  }"
                />
              </div>
            </div>
          </div>
          <button
            v-if="canAddToAppleWallet && !isGICConfType"
            type="button"
            :disabled="isAddingToWallet"
            class="flex items-center gap-[10px] h-[52px] px-[22px] rounded-[10px] bg-black text-white disabled:opacity-50"
            data-event-tracking="gensapp-qrcode-add-to-apple-wallet"
            data-test-id="gensapp-qrcode-apple-wallet"
            @click="onAppleWalletTap"
          >
            <img src="../../public/assets/icons/apple-wallet.svg" alt="" class="h-[26px] w-auto" />
            <span v-if="isAddingToWallet" class="text-[18px] font-semibold">Saving…</span>
            <span v-else class="flex flex-col items-start leading-[1.05]">
              <span class="text-[12px] font-medium">Add to</span>
              <span class="text-[20px] font-semibold">Apple Wallet</span>
            </span>
          </button>
          <button
            v-if="canAddToGoogleWallet && !isGICConfType"
            type="button"
            :disabled="isAddingToWallet"
            class="flex items-center gap-[10px] h-[52px] px-[22px] rounded-[10px] bg-black text-white disabled:opacity-50"
            data-event-tracking="gensapp-qrcode-add-to-google-wallet"
            data-test-id="gensapp-qrcode-google-wallet"
            @click="onGoogleWalletTap"
          >
            <img src="../../public/assets/icons/google-wallet.svg" alt="" class="h-[26px] w-auto" />
            <span v-if="isAddingToWallet" class="text-[18px] font-semibold">Saving…</span>
            <span v-else class="flex flex-col items-start leading-[1.05]">
              <span class="text-[12px] font-medium">Add to</span>
              <span class="text-[20px] font-semibold">Google Wallet</span>
            </span>
          </button>
        </div>
      </div>
    </div>
  </master-layout>
</template>

<script>
import { mapState } from 'vuex';
import QrcodeVue from 'qrcode.vue';
import BackButton from '@/components/common/BackButton.vue';
import platformMixin from '@/mixins/platformMixin';
import walletPassMixin from '@/mixins/walletPassMixin';
import { getCurrentConferenceType } from '@/utils/conference-type';

export default {
  name: 'QrCode',
  mixins: [platformMixin, walletPassMixin],
  components: {
    QrcodeVue,
    BackButton,
  },
  data() {
    return {
      isShowQR: false,
      isSamsung: false,
    };
  },
  computed: {
    ...mapState('profile', ['hashId', 'confYear', 'conferences']),
    isGICConfType() {
      return getCurrentConferenceType(this.confYear, this.conferences) === 'GIC';
    },
    showHeader() {
      return this.$route.path !== '/home';
    },
  },
  mounted() {
    if (navigator.userAgent.match(/samsung/i)) {
      this.isSamsung = true;
    }
  },
  methods: {
    back() {
      if (this.isEditEnable) {
        this.toggleEdit();
        return;
      }
      this.$router.back();
    },
  },
};
</script>
<style scoped></style>
